export enum DocVisibility {
  Private = "private",
  Public = "public",
}

export function isDocVisibility(value: any): value is DocVisibility {
  return Object.values(DocVisibility).includes(value);
}
